import { getRecommendationType, mapToEcommerceItem, } from '@pegasus/tracker';
import { PlusBenefitType } from '@pegasus/plus';
import { tracker } from '../track';
import { formatItemName, formatPrice, formattedSimples, getGA4Context, getTrackingDiscountedPrice, toItemAvailability, } from '../../helpers';
export const trackSelectItem = (payload, options) => {
    var _a, _b;
    try {
        const { context, element, item, itemListName, recommended, themeHash } = payload;
        const recommendationType = getRecommendationType(recommended);
        tracker.track('GA4-EEC-select_item', {
            event_name: 'select_item',
            select_item: {
                context: context || getGA4Context(),
                element: element || null,
                theme_hash: themeHash || null,
                items: [
                    mapToEcommerceItem(Object.assign({ affiliation: String(item.categoryId), discount: getTrackingDiscountedPrice({
                            specialPriceInCents: (item === null || item === void 0 ? void 0 : item.specialPrice) || 0,
                            priceInCents: (item === null || item === void 0 ? void 0 : item.price) || 0,
                            savingsPercent: (item === null || item === void 0 ? void 0 : item.savings) || 0,
                            context: 'select_item',
                        }), early_access_item: item.plusEarlyAccess || false, index: 0, item_availability: toItemAvailability(item.stockStatus), item_id: item.sku, item_list_name: itemListName || null, item_name: formatItemName(item), item_brand: item.brandCode, item_variant: item.simpleSku || null, feature_flag: item.energy_efficiency_class ? 'energy_modal' : null, item_info: item.energy_efficiency_class
                            ? `energy_score_${item.energy_efficiency_class}`
                            : null, price: formatPrice(item.specialPrice), product_gender: (item.gender || []).toString() ||
                            null, promotion_id: item.campaignIdentifier, quantity: item.quantity || null, recommended: recommendationType, size_availability: formattedSimples(item, 'filterValue'), product_delivery_dates: item.deliveryPromise
                            ? `${item.deliveryPromise.beginDate}_${item.deliveryPromise.endDate}`
                            : null, plus_exclusive: ((_a = item === null || item === void 0 ? void 0 : item.plusBenefit) === null || _a === void 0 ? void 0 : _a.type) === PlusBenefitType.Exclusive }, (_b = options === null || options === void 0 ? void 0 : options.customMapper) === null || _b === void 0 ? void 0 : _b.call(options, item))),
                ],
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `select_item` failed.', e);
    }
};
